export interface PurchaseData {
  customerId: string;
  amount: string;
  confirmation: string;
  ticketNum: string;
  registeredBy: string;
}

export const emptyPurchaseData: PurchaseData = {
  customerId: "",
  amount: "",
  confirmation: "",
  ticketNum: "",
  registeredBy: "admin",
};
